import { FC } from 'react';
import { Dropdown } from '@carbon/react';
import styles from './type-curves-listing.module.scss';

export const CATALOG_ITEMS = [
  { id: 0, text: 'Type Curves' },
  { id: 1, text: 'Type Curve Workspaces' },
  { id: 2, text: 'Type Curve Scenarios' },
  { id: 3, text: 'Inventory Workspaces' },
] as const;

type CatalogItem = (typeof CATALOG_ITEMS)[number];

interface TypeCurvesContentSwitcherProps {
  activeTab: number;
  onChange: (tab: number) => void;
}

export const TypeCurvesContentSwitcher: FC<TypeCurvesContentSwitcherProps> = ({
  activeTab,
  onChange,
}) => (
  <Dropdown
    id="tc-listing-catalog-switcher"
    titleText=""
    label="Select view"
    size="lg"
    className={styles.contentSwitcher}
    items={CATALOG_ITEMS as unknown as CatalogItem[]}
    itemToString={(item: CatalogItem | null) => item?.text ?? ''}
    selectedItem={CATALOG_ITEMS[activeTab] ?? CATALOG_ITEMS[0]}
    onChange={({ selectedItem }: { selectedItem: CatalogItem | null }) => {
      if (selectedItem !== null && selectedItem !== undefined)
        onChange(selectedItem.id);
    }}
  />
);
